export var LoginRegisterText;
(function (LoginRegisterText) {
    LoginRegisterText["LOGIN"] = "Log in";
    LoginRegisterText["SIGN_UP"] = "Sign up";
    LoginRegisterText["FORGOT_PASSWORD"] = "Forgot your password?";
    LoginRegisterText["DONT_HAVE_ACCOUNT"] = "Don't have an account yet?";
    LoginRegisterText["ALREADY_HAVE_ACCOUNT"] = "Already have an account?";
    LoginRegisterText["EMAIL"] = "Email";
    LoginRegisterText["PASSWORD"] = "Password";
    LoginRegisterText["CONFIRM_PASSWORD"] = "Confirm password";
    LoginRegisterText["FIRST_NAME"] = "First name";
    LoginRegisterText["LAST_NAME"] = "Last name";
    LoginRegisterText["PHONE"] = "Phone";
    LoginRegisterText["COUNTRY"] = "Country";
    LoginRegisterText["VALID_EMAIL"] = "Please enter a valid email address";
    LoginRegisterText["REGISTRATION_FAILURE"] = "Registration Failure";
    LoginRegisterText["PASSWORDS_MUST_MATCH"] = "Passwords must match";
    LoginRegisterText["SHORT_PASSWORD"] = "Password must be at least 6 characters";
    LoginRegisterText["INVALID_PHONE"] = "Please enter a valid phone number";
    LoginRegisterText["SELECT_REFERRAL"] = "Please select a referral";
    LoginRegisterText["FORGOT_PASSWORD_EMAIL_REQUIRED"] = "Please enter email address for forgotten password then click forgot your password again";
    LoginRegisterText["ACCEPT_PRIVACY_POLICY"] = "You must accept the privacy policy in order to register.";
    LoginRegisterText["LEARN_MORE"] = "Learn more";
    LoginRegisterText["HOW_DID_YOU_HEAR_ABOUT_US"] = "How did you hear about us?";
})(LoginRegisterText || (LoginRegisterText = {}));
export var TabValues;
(function (TabValues) {
    TabValues[TabValues["LOGIN"] = 1] = "LOGIN";
    TabValues[TabValues["REGISTER"] = 2] = "REGISTER";
})(TabValues || (TabValues = {}));
